export default __webpack_public_path__ + "static/media/indian retailer.09b96a4f.png";